import { useInitActionCombo } from '../../../commons/combobox/initActionCombo.js';

import { useRemoteCombobox } from '@/setup/remoteCombobox.js';
import { reactive, getCurrentInstance, ref, computed } from 'vue';

export const useBAWithDrawDetailData = () => {
  const { proxy } = getCurrentInstance();
  const { comboboxLoadData, submitQuickAdd } = useRemoteCombobox();

  // Tạo object lưu dữ liệu các field
  const comboboxDataRemote = reactive({
    debit_account: [],
    credit_account: [],
    budget_source_name: [],
    budget_chapter_code: [],
    budget_sub_kind_item_code: [],
    budget_item_code: [],
    budget_sub_item_code: [],
    method_distribute_name: [],
    cash_withdraw_type_name: [],
    project_code: [],
    task_code: [],
    bank_account: [],
    budget_fees_code: [],
    activity_name: [],
  });

  // Init các field của grid hạch toán đồng thời
  const initGridColumnParallel = () => {
    return [
      {
        caption: 'Diễn giải',
        dataField: 'description',
        width: 250,
        editable: true,
        columnType: proxy.$ms.constant.ColumnType.Text,
        sortable: true,
      },
      {
        caption: 'TK Nợ',
        dataField: 'debit_account',
        width: 100,
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        title: 'Tài khoản Nợ',
        sortable: true,
      },
      {
        caption: 'TK Có',
        dataField: 'credit_account',
        width: 100,
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        title: 'Tài khoản Có',
        sortable: true,
      },
      {
        caption: 'Số tiền',
        dataField: 'amount_oc',
        width: 150,
        editable: true,
        columnType: proxy.$ms.constant.ColumnType.Number,
        formatType: proxy.$ms.constant.FormatType.Amount,
        summaryType: proxy.$ms.constant.SummaryType.Sum,
        sortable: true,
      },
      {
        caption: 'Quy đổi',
        dataField: 'amount',
        width: 150,
        editable: true,
        columnType: proxy.$ms.constant.ColumnType.Number,
        formatType: proxy.$ms.constant.FormatType.Amount,
        summaryType: proxy.$ms.constant.SummaryType.Sum,
        visible: false,
        sortable: true,
        rules: [{ name: 'lessThanAmount', compareValue: 100000000000000 }],
      },
      {
        width: 136,
        caption: 'Mã dự phòng',
        dataField: 'budget_provide_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        visible: false,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Nguồn',
        dataField: 'budget_source_name',
        width: 250,
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Chương',
        dataField: 'budget_chapter_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        width: 100,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Loại',
        dataField: 'budget_kind_item_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        width: 100,
        editable: true,
        sortable: true,
        visible: false,
      },
      {
        caption: 'Khoản',
        dataField: 'budget_sub_kind_item_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        width: 100,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Mục',
        dataField: 'budget_item_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        width: 100,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Tiểu mục',
        dataField: 'budget_sub_item_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        width: 100,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Tiết tiểu mục',
        dataField: 'budget_detail_item_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        width: 100,
        editable: true,
        sortable: true,
        visible: false,
      },
      {
        caption: 'Cấp phát',
        dataField: 'method_distribute_name',
        columnType: proxy.$ms.constant.ColumnType.Enum,
        editable: true,
        formatType: proxy.$ms.constant.FormatType.Enum,
        width: 136,
        sortable: true,
        enum: 'MethodDistributeType',
      },
      {
        caption: 'Nghiệp vụ',
        dataField: 'cash_withdraw_type_name',
        columnType: proxy.$ms.constant.ColumnType.Enum,
        editable: true,
        formatType: proxy.$ms.constant.FormatType.Enum,
        width: 136,
        sortable: true,
        enum: 'CashWithDrawType',
      },
      {
        width: 136,
        caption: 'Mã thống kê',
        dataField: 'statistic_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        sortable: true,
        visible: false,
      },
      {
        caption: 'Đối tượng',
        dataField: 'accounting_object_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        sortable: true,
        width: 136,
        visible: false,
      },
      {
        caption: 'Loại quỹ',
        dataField: 'fund_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        visible: false,
        width: 136,
        editable: true,
        sortable: true,
      },
      {
        width: 136,
        caption: 'Cơ cấu vốn',
        dataField: 'fund_structure_name',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        visible: false,
        editable: true,
        sortable: true,
      },
      {
        width: 136,
        caption: 'Nhiệm vụ',
        dataField: 'task_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        visible: false,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Hoạt động',
        dataField: 'activity_name',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        width: 136,
        editable: true,
        sortable: true,
      },
      {
        width: 136,
        caption: 'Đề tài',
        dataField: 'topic_code',
        visible: true,
        editable: true,
        sortable: true,
        columnType: proxy.$ms.constant.ColumnType.Combobox,
      },
      {
        caption: 'CTMT, dự án',
        title: 'Chương trình mục tiêu, dự án',
        dataField: 'project_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        width: 136,
        sortable: true,
      },
      {
        caption: 'Tài khoản NH, KB',
        title: 'Tài khoản ngân hàng, kho bạc',
        dataField: 'bank_account',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        width: 136,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Phí, lệ phí',
        title: 'Phí, lệ phí',
        dataField: 'budget_fees_code',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        editable: true,
        width: 136,
        sortable: true,
      },
      {
        width: 136,
        caption: 'Hợp đồng',
        columnType: proxy.$ms.constant.ColumnType.Combobox,
        dataField: 'contract_no',
        editable: true,
        sortable: true,
      },
      {
        caption: 'Số lượng',
        dataField: 'quantity',
        width: 150,
        editable: true,
        visible: false,
        columnType: proxy.$ms.constant.ColumnType.Number,
        formatType: proxy.$ms.constant.FormatType.Amount,
        summaryType: proxy.$ms.constant.SummaryType.Sum,
        sortable: true,
      },
      {
        caption: 'Đơn giá',
        dataField: 'unitprice',
        width: 150,
        editable: true,
        visible: false,
        columnType: proxy.$ms.constant.ColumnType.Number,
        formatType: proxy.$ms.constant.FormatType.Amount,
        summaryType: proxy.$ms.constant.SummaryType.Sum,
        sortable: true,
      },
      {
        caption: 'Định mức',
        dataField: 'norm',
        width: 150,
        editable: true,
        visible: false,
        columnType: proxy.$ms.constant.ColumnType.Number,
        formatType: proxy.$ms.constant.FormatType.Amount,
        summaryType: proxy.$ms.constant.SummaryType.Sum,
        sortable: true,
      },
      {
        caption: 'Số HĐ',
        title: 'Số hóa đơn',
        dataField: 'inv_no',
        visible: false,
        columnType: proxy.$ms.constant.ColumnType.Text,
        width: 136,
        editable: true,
        sortable: true,
      },
      {
        caption: 'Ngày hóa đơn',
        dataField: 'inv_date',
        visible: false,
        columnType: proxy.$ms.constant.ColumnType.Datepicker,
        formatType: proxy.$ms.constant.FormatType.Date,
        width: 136,
        editable: true,
        sortable: true,
      },
      {
        width: 136,
        caption: 'Nguồn năm trước',
        visible: false,
        editable: true,
        sortable: true,
        dataField: 'is_source_before_year',
        columnType: proxy.$ms.constant.ColumnType.Checkbox,
      },
      {
        caption: '',
        dataField: 'rowAction',
        width: 80,
        columnType: proxy.$ms.constant.ColumnType.Action,
        sortable: false,
      },
    ];
  };

  // Khởi tạo các field của grid
  const columnParallel = reactive(initGridColumnParallel());

  // toggle detail
  const toggleAbove = ref(true);
  const toggleAboveHandler = () => {
    toggleAbove.value = !toggleAbove.value;
  };

  // Active tab hạch toán hay thống kê
  const selectedTab = ref(1);
  const currentLayout = ref('BAWithDrawDetail')
  const selectedTabHandler = value => {
    selectedTab.value = value;
  };

  /**
   * Biến dùng để disabled Sinh chứng từ chuyển khoản KB vào TK tiền gửi
   * NXCHIEN 26.04.2022
   */
  const valueMode = computed(() => {
    return proxy.editMode != proxy.$ms.constant.FormState.View;
  });

  /**
   * Biến dùng để disabled tiện ích theo trường ghi sổ
   */
  const isPosted = computed(() => {
    return proxy.model.is_posted;
  });

  /**
   * Biến lưu trạng thái của form khi ở mode view
   * NVTUAN1 09.08.2022
   */
  const valueModeView = computed(() => {
    return proxy.editMode == proxy.$ms.constant.FormState.View;
  });

  /**
   * Biến dùng để disabled Xóa nếu chứng từ đã ghi sổ
   */
  const disabledDelete = computed(() => {
    return proxy.editMode != proxy.$ms.constant.FormState.View || proxy.model.is_posted;
  });

  // item của button tiện ích CK tiền gửi
  const buttonTransferDeposit = reactive([
    // {
    //   text: 'Xóa',
    //   command: 'Delete',
    //   seperatorBottom: true,
    //   disabledItem: valueMode,
    // },
    {
      text: 'Thêm mới từ chứng từ hiện thời',
      command: 'Duplicate',
      disabledItem: valueMode,
    },
    {
      text: 'Sinh giấy rút dự toán...',
    },
    {
      text: 'Sinh chứng từ trả lương',
    },
  ]);

  // item của button tiện ích CK kho bạc
  const buttonTransfer = reactive([
    // {
    //   text: 'Xóa',
    //   command: 'Delete',
    //   seperatorBottom: true,
    //   disabledItem: valueMode,
    // },
    {
      text: 'Thêm mới từ chứng từ hiện thời',
      command: 'Duplicate',
      disabledItem: valueMode,
    },
    {
      text: 'Sinh giấy rút dự toán...',
    },
    {
      text: 'Sinh chứng từ trả lương',
    },
  ]);

  // item button in
  const buttonPrints = [
    {
      text: 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)',
      command: 'receipt',
    },
    {
      text: 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)(Mẫu dọc-tùy chỉnh)',
      command: 'receipt',
    },
    {
      text: 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)(Mẫu dọc)',
      command: 'receipt',
    },
    {
      text: 'Bảng kê nội dung thanh toán/tạm ứng (Nghị định 11/2020/NĐ-CP)(Mẫu tùy chỉnh)',
      command: 'receipt',
    },
    { text: 'Bảng kê nộp thuế (Nghị định 11/2020/NĐ-CP)', command: 'receipt' },
    {
      text: 'C1-02/NS: Giấy nộp tiền vào ngân sách nhà nước (Nghị định 11/2020/NĐ-CP)',
      command: '157.C1_02_NS_ND11',
    },
    {
      text: 'C2-05a/NS: Giấy nộp trả kinh phí (Nghị định 11/2020/NĐ-CP)',
      command: '157.C2_05_NS_ND11',
    },
    {
      text: 'C4-02a/KB: Ủy nhiệm chi (Nghị định 11/2020/NĐ-CP)',
      command: 'receipt',
    },
    {
      text: 'C4-02b/KB: Ủy nhiệm chi ngoại tệ (Nghị định 11/2020/NĐ-CP)',
      command: 'receipt',
    },
    {
      text: 'C4-02c/KB: Uỷ nhiệm chi (Nghị định 11/2020/NĐ-CP)',
      command: 'receipt',
    },
    { text: 'Bảng kê nộp thuế (TT số 84/2016/TT-BTC)', command: 'receipt' },
    {
      text: 'C3-04/NS: Giấy nộp trả vốn đầu tư (Thông tư số 77/2017/TT-BTC)',
      command: 'receipt',
    },
    { text: 'C37-HD: Giấy đề nghị thanh toán', command: 'receipt' },
    { text: 'C40-BB: Phiếu thu', command: 'receipt' },
    { text: 'C40-BB: Phiếu thu (2 liên)', command: 'receipt' },
    {
      text: 'C4-11/KB: Giấy chuyển tiền chuyển khoản, chuyển tiền điện tử (Thông tư số 77/2017/TT-BTC)',
      command: 'receipt',
    },
    { text: 'Chứng từ kế toán', command: 'receipt' },
    { text: 'Chứng từ kế toán (Mẫu nguyên tệ)', command: 'receipt' },
    { text: 'C40-BB: Phiếu thu (2 liên - Mẫu Tiểu mục)', command: 'receipt' },
    { text: 'C40-BB: Phiếu thu (2 liên A5)', command: 'receipt' },
    { text: 'C40-BB: Phiếu thu (Giấy cuộn -  A5)', command: 'receipt' },
    {
      text: 'C40-BB: Phiếu thu (Mẫu chi tiết nghiệp vụ kế toán)',
      command: 'receipt',
    },
    { text: 'C40-BB: Phiếu thu (Mẫu Tiểu mục)', command: 'receipt' },
    { text: 'C40-BB: Phiếu thu (nhiều dòng)', command: 'receipt' },
    { text: 'Lệnh chi (VietinBank)', command: 'receipt' },
    { text: 'Ủy nhiệm chi (Agribank)', command: 'receipt' },
    { text: 'Ủy nhiệm chi (BIDV)', command: 'receipt' },
    { text: 'Ủy nhiệm chi (Vietcombank)', command: 'receipt' },
    { text: 'Ủy nhiệm chi (Vietinbank)', command: 'receipt' }, // mẫu Excel:
    { text: 'Ủy nhiệm chi (ACB)', command: 'receipt' },
    { text: 'Ủy nhiệm chi (Agribank)', command: 'receipt' },
    { text: 'Ủy nhiệm chi (BIDV)', command: 'receipt' },
    { text: 'Ủy nhiệm chi (Techcombank)', command: 'receipt' },
    { text: 'Ủy nhiệm chi (Vietcombank)', command: 'receipt' },
    { text: 'Tùy chọn in', command: 'receipt' },
  ];

  // item nút tiện ích
  const buttonUtilities = reactive([
    {
      text: 'Thêm chứng từ',
      command: proxy.$ms.constant.Command.Add,
      disabledItem: valueMode,
    },
    {
      text: 'Thêm mới từ chứng từ hiện thời',
      command: proxy.$ms.constant.Command.Duplicate,
      disabledItem: valueMode,
      IsSubMenu: true,
      subItem: [
        {
          text: 'Chuyển khoản kho bạc vào tài khoản tiền gửi',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'BUTransferDepositDetail',
          refType: proxy.$ms.constant.RefType.BUTransferDeposit
        },
        {
          text: 'Thu tiền gửi',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'BADepositDetail',
          refType: proxy.$ms.constant.RefType.BADeposit
        },
        {
          text: 'Chi tiền gửi',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'BAWithDrawDetail',
          refType: proxy.$ms.constant.RefType.BAWithDraw,
          initial: true
        },
        {
          text: 'Chuyển khoản kho bạc',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'BUTransferDetail',
          refType: proxy.$ms.constant.RefType.BUTransfer
        },
        {
          text: 'Phiếu chi',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'CAPaymentDetail',
          refType: proxy.$ms.constant.RefType.CAPayment,
        },
        {
          text: 'Phiếu thu',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'CAReceiptDetail',
          refType: proxy.$ms.constant.RefType.CAReceipt
        },
        {
          text: 'Chứng từ nghiệp vụ khác',
          command: proxy.$ms.constant.Command.Duplicate,
          form: 'GLGeneralVoucherDetail',
          refType: proxy.$ms.constant.RefType.GLGeneralVoucher
        },
      ]
    },
    // {
    //   text: 'Xóa chứng từ hiện thời',
    //   command: proxy.$ms.constant.Command.Delete,
    //   disabledItem: disabledDelete,
    // },
    {
      text: 'Xem số dư tài khoản',
      command: proxy.$ms.constant.Command.ViewAccount,
    },
    {
      text: 'Xem số dư tạm ứng',
      command: proxy.$ms.constant.Command.ViewAdvanceBalance,
    },
    {
      text: 'Sao chép chứng từ',
      command: proxy.$ms.constant.Command.Copy,
      disabledItem: valueModeView,
    },
    {
      text: 'Hạch toán chi phí lương',
      command: proxy.$ms.constant.Command.GenerateDataFundSalary,
      disabledItem: valueMode,
    },
    {
      text: 'Hạch toán chi phí bảo hiểm',
      command: proxy.$ms.constant.Command.GenerateDataFundInsurance,
      disabledItem: valueMode,
    },
    {
      text: 'Cất thành định khoản tự động',
      command: proxy.$ms.constant.Command.AddAutoBusiness,
    },
  ]);

  /**
   * (custom) copy cột xuống các dòng dưới
   * @param {*} objAssign : Dữ liệu để merge vào dòng đó
   * @param {*} metaData : Dữ liệu dòng hoặc dữ liệu vừa chọn combo
   * @param {*} column : Cột đang copy
   * @param {*} $grid : Grid
   * @param {*} lastIndex: các dòng được copy rowIndex => lastIndex
   * @param {*} rowIndex: Dòng đang active
   * @param {*} isShowCombo: MetaData lấy từ dòng dữ liệu hay lấy từ xổ combo
   * DMNGOC (08.11.2022)
   */
  function copyDownRowExtend(objAssign, metaData, column, $grid, lastIndex, rowIndex, isShowCombo) {
    switch (column.dataField) {
      case 'accounting_object_code':
        for (let i = rowIndex; i < lastIndex + 1; i++) {
          let item = $grid.dataView[i];
          item.accounting_object_code = objAssign.accounting_object_code ? metaData.accounting_object_code : null;
          item.accounting_object_name = objAssign.accounting_object_code ? metaData.accounting_object_name : null;
          item.accounting_object_id = objAssign.accounting_object_code ? metaData.accounting_object_id : null;
          item.company_tax_code = objAssign.company_tax_code || metaData.company_tax_code;
          item.accounting_object_address = objAssign.accounting_object_address || metaData.accounting_object_address || metaData.address;
        }
        break;
      case 'turn_over': // Giá tính thuế
        for (let i = rowIndex; i < lastIndex + 1; i++) {
          let item = $grid.dataView[i];
          let taxOver = objAssign.turn_over || 0;
          if (taxOver && item) {
            let taxRate = item.tax_rate || 0;
            //Tính tiền thuế = Giá tính thuế * thuế suất * tỷ giá (nếu loại tiền khác VND) và cập nhật lên grid
            let taxAmountValue;
            if (taxRate == proxy.$ms.constant.TaxRateInventory.NoSelected) {
              taxAmountValue = 0;
            } else {
              taxAmountValue = (taxRate * taxOver) / 100;
            }
            item.tax_amount = taxAmountValue;
          }
        }
        break;
      case 'tax_rate':
        for (let i = rowIndex; i < lastIndex + 1; i++) {
          let item = $grid.dataView[i];
          let taxRate1 = objAssign.tax_rate || 0;
          if (taxRate1 && item) {
            let taxOver = item.turn_over || 0;
            //Tính tiền thuế = Giá tính thuế * thuế suất * tỷ giá (nếu loại tiền khác VND) và cập nhật lên grid
            let taxAmountValue;
            if (taxRate1 == proxy.$ms.constant.TaxRateInventory.NoSelected) {
              taxAmountValue = 0;
            } else {
              taxAmountValue = (taxRate1 * taxOver) / 100;
            }
            item.tax_amount = taxAmountValue;
          }
        }
        break;
      case 'quantity':
        for (let i = rowIndex; i < lastIndex + 1; i++) {
          let item = $grid.dataView[i];
          if (item) {
            let amountOc = item.amount || 0;
            item.unitprice = objAssign.quantity && objAssign.quantity > 0 ? amountOc / objAssign.quantity : 0;
          }
        }
        break;
      case 'amount':
      case 'amount_oc':
        for (let i = rowIndex; i < lastIndex + 1; i++) {
          let item = $grid.dataView[i];
          if (item) {
            let amountOc = objAssign.amount || 0;
            item.unitprice = objAssign.quantity && objAssign.quantity > 0 ? amountOc / objAssign.quantity : 0;
          }
        }
        break;
      default:
        break;
    }
  }

  //#region khởi tạo config cho combox trong grid
  const {
    budgetSourceComboConfig,
    budgetChapterComboConfig,
    budgetSubKindItemComboConfig,
    budgetItemComboConfig,
    budgetSubItemComboConfig,
    budgetDetailItemComboConfig,
    budgetKindItemComboConfig,
    accountComboMostDetailConfig,
    projectComboConfig,
    accountingObjectComboConfig,
    activityComboConfig,
    statisticComboConfig,
    bankAccountComboConfig,
    purchasePurposeComboConfig,
    budgetFeesComboConfig,
    TaskComboConfig,
    bankInfoComboConfig,
    typeOfFundComboConfig,
    contractComboConfig,
    accountComboParalellConfig,
    fundStructureComboConfig,
    budgetProvideComboConfig,
    topicComboConfig,
    accountComboConfig,
  } = useInitActionCombo(comboboxDataRemote, comboboxLoadData);
  //#endregion

  return {
    buttonTransfer,
    buttonTransferDeposit,
    buttonPrints,
    comboboxDataRemote,
    columnParallel,
    toggleAbove,
    toggleAboveHandler,
    selectedTab,
    currentLayout,
    selectedTabHandler, // config các field của grid ở dạng combo
    budgetSourceComboConfig,
    budgetChapterComboConfig,
    budgetSubKindItemComboConfig,
    budgetItemComboConfig,
    budgetSubItemComboConfig,
    budgetDetailItemComboConfig,
    budgetKindItemComboConfig,
    accountComboMostDetailConfig,
    projectComboConfig,
    accountingObjectComboConfig,
    activityComboConfig,
    statisticComboConfig,
    bankAccountComboConfig,
    purchasePurposeComboConfig,
    budgetFeesComboConfig,
    TaskComboConfig,
    bankInfoComboConfig,
    typeOfFundComboConfig,
    contractComboConfig,
    accountComboParalellConfig,
    fundStructureComboConfig,
    budgetProvideComboConfig,
    topicComboConfig,
    accountComboConfig, // func combo
    submitQuickAdd,
    comboboxLoadData,
    buttonUtilities,
    copyDownRowExtend,
  };
};
